import { colors } from '@insurancemenu/imenu-components-lib';
import { boxShadows } from '@insurancemenu/imenu-components-lib/dist/utils';
import { createUseStyles } from 'react-jss';

const styles = {
  actionBar: {
    margin: '0 auto 8rem',
    display: 'flex',
    alignItems: 'flex-end',
    gap: '3rem',
    justifyContent: 'space-between',
    '@media(max-width:958px)': {
      alignItems: 'center',
      flexDirection: 'column',
    },
  },
  buttonsBar: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '3rem',
    justifyContent: 'center',
  },
  uploadButton: {
    width: '25rem',
  },
  tableWrapper: {
    backgroundColor: colors.neutral.white,
    borderRadius: '1rem',
    maxWidth: '170rem',
    margin: '0 auto',
    boxShadow: boxShadows.dark[4],
    overflow: 'hidden',
  },
  table: {
    width: 'max(100%, 108rem)',
  },
  tableBody: {
    boxSizing: 'border-box',
  },
  tableHeader: {
    boxSizing: 'border-box',
  },
  tableHeading: {
    padding: '1.6rem 0.5rem',
    width: '4rem',
    '&:first-child': {
      paddingLeft: '2.4rem',
    },
    '&:last-child': {
      paddingRight: '2.4rem',
    },
  },
  longFileInfo: {
    width: '7rem',
    paddingRight: '2rem',
  },
  selectedFile: {
    margin: '0 0.5rem',
    color: colors.neutral[900],
    wordBreak: 'break-all',
    lineHeight: '3rem',
  },
  infoTitle: {
    margin: '0 0 2rem',
    fontSize: '1.6rem',
    textAlign: 'right',
  },
  totalAmount: {
    marginLeft: '1rem',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
